import { fetchFilters, selectFilters, selectFiltersStatus, selectSortMethod, updateLocation } from './menu/filtersSlice'
import { fetchMapLocations, fetchMapStatus, selectMapOptions, selectMapStatus, updateMapOption } from './Map/mapSlice'
import { fetchLocations, selectLocationStatus } from './Result/locationSlice'
import { LOCATION_STATES, STATUS } from 'utils/constants'
import { useDispatch, useSelector } from 'react-redux'
import { PROVINCES } from '../MapSearch/constants'
import { useHistory } from 'react-router-dom'
import { useEffect, useRef } from 'react'

const Controller = ({ isMobile }) => {
  const { distance, position, voivodship } = useSelector(selectMapOptions)
  const locationStatus = useSelector(selectLocationStatus)
  const filtersStatus = useSelector(selectFiltersStatus)
  const mapStatus = useSelector(selectMapStatus)
  const filters = useSelector(selectFilters)
  const sort = useSelector(selectSortMethod)

  const dispatch = useDispatch()

  const filtersRef = useRef(null)
  const firstLaunch = useRef(true)
  const mapStatusController = useRef(null)
  const locationFetchesController = useRef(null)

  const { push, replace } = useHistory()

  useEffect(() => {
    const search = window.location.search
    if (search) {
      const query = new URLSearchParams(search)
      const location = query.get('location')
      const distance = query.get('distance')
      const gpslatitude = query.get('gpslatitude')
      const gpslongitude = query.get('gpslongitude')
      // const radius = query.get('radius')
      const isValidDistance = !!distance && Number(distance) > 0
      const isValidPosition = !!(gpslatitude && gpslongitude)

      if (location) {
        dispatch(updateLocation(location))
      }

      if (isValidPosition || isValidDistance) {
        const options = {}
        if (isValidDistance) {
          options.distance = distance
        }
        if (isValidPosition) {
          options.position = [gpslatitude, gpslongitude]
          options.showMarker = true
        }
        dispatch(updateMapOption(options))
      }

      if (location || isValidDistance || isValidPosition) {
        replace(window.location.pathname)
      }
    }
  }, [dispatch, replace])

  useEffect(() => {
    if (filtersStatus !== STATUS.succeed) dispatch(fetchFilters())
  }, [filtersStatus, dispatch])

  useEffect(() => {
    if (locationStatus === STATUS.succeed && mapStatus === STATUS.succeed) locationFetchesController.current = null
  }, [locationStatus, mapStatus])

  useEffect(() => {
    if (locationFetchesController.current) {
      locationFetchesController.current.abort()
      locationFetchesController.current = null
    }

    if (mapStatusController.current) {
      mapStatusController.current.abort()
      mapStatusController.current = null
    }

    const controller = new AbortController()
    const signal = controller.signal
    const isVoivodship = voivodship !== undefined
    const body = generateBody(filters, position, distance, voivodship, sort)

    if (filtersRef.current !== filters) dispatch(fetchMapLocations({ body, signal }))
    if (!isMobile || position || isVoivodship) dispatch(fetchLocations({ body, signal })).then(({ payload }) => {
      if (firstLaunch.current && payload && payload?.places?.filteredAndLocalized?.length === 0 && payload?.places?.localized?.length === 0) {
        push(window.location.pathname, LOCATION_STATES.popup('findplace'))
        firstLaunch.current = false
      }
    })

    locationFetchesController.current = controller
    filtersRef.current = filters
  }, [dispatch, isMobile, sort, distance, filters, position, push, voivodship])

  useEffect(() => {
    if (mapStatus === STATUS.succeed || mapStatus === STATUS.failed) {
      let interval = setInterval(() => {
        const controller = new AbortController()
        const signal = controller.signal
        const body = generateBody(filters, position, distance, voivodship, sort)

        mapStatusController.current = controller
        dispatch(fetchMapStatus({ body, signal }))
          .then(() => mapStatusController.current = null)
      }, 30000)

      return () => clearInterval(interval)
    }
  }, [dispatch, distance, filters, mapStatus, position, sort, voivodship])

  return false
}

export const generateBody = (filters, position, distance, voivodship, sort) => {
  const body = {
    filters: position
      ? { ...filters, position, distance }
      : voivodship !== undefined
        ? { ...filters, location: PROVINCES[voivodship].search, distance: '0' }
        : filters
  }
  // if (sort) {
  //   body.orderBy = 'min_month_price'
  //   body.sortedBy = sort === 'cheapest' ? 'asc' : 'desc'
  // }
  return body
}

export default Controller